module.exports = __webpack_public_path__ + "img/thumbnail_RedKangaroo_f_albino.2132bc07.png";